export const fi = {
  courses: '/kurssit',
  coursePage: '/kurssit/:courseNumber',
};
export const sv = {
  courses: '/kurser',
  coursePage: '/kurser/:courseNumber',
};
export const en = {
  courses: '/courses',
  coursePage: '/courses/:courseNumber',
};

export default {
  fi,
  sv,
  en,
};
